// extracted by mini-css-extract-plugin
export var active = "_95-a";
export var activeIndicator = "_95-9";
export var disabled = "_95-b";
export var fullWidth = "_95-2";
export var lg = "_95-7";
export var md = "_95-6";
export var redoButtonTabGroup = "_95-0";
export var sm = "_95-5";
export var tabButton = "_95-4";
export var tabButtonsContainer = "_95-1";
export var themeDestructive = "_95-d";
export var themeNormal = "_95-c";
export var themeSuccess = "_95-e";
export var xl = "_95-8";
export var xs = "_95-3";